export default __webpack_public_path__ + "static/media/home-bg1.f253af40.png";